import React, { useState } from 'react';
import { Button } from '@mui/material';
import { useStoresContext } from './stores.context';

const ExportCsv = () => {
  const { exportCsv } = useStoresContext();
  const [loading, setLoading] = useState(false);

  const handleExportCsv = async () => {
    try {
      setLoading(true);
      await exportCsv();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      onClick={() => handleExportCsv()}
      variant='contained'
      color='secondary'
      disabled={loading}
    >
      {loading ? 'Exporting...' : 'Export CSV'}
    </Button>
  );
};

export default ExportCsv;
